module.exports = __webpack_public_path__ + "img/symbol_9.bc63286b.png";